import React, { createContext, useCallback, useContext, useState } from 'react';
import { XIcon } from 'lucide-react';
import type { WaitlistPreviewState } from '../hooks/useMcpWaitlist';
import { trackEvent } from '../utils/analytics';
import { Dialog } from '../components/ui/Dialog';
import { McpWaitlistForm } from '../components/mcp/McpWaitlistForm';
type McpWaitlistContextValue = {
  openWaitlist: (placement: string) => void;
  preview: WaitlistPreviewState;
};
const McpWaitlistContext = createContext<McpWaitlistContextValue>({
  openWaitlist: () => undefined,
  preview: 'live'
});
export const useMcpWaitlistPopup = () => useContext(McpWaitlistContext);

/** Provides the site-wide "Join the MCP waitlist" popup. */
export function McpWaitlistProvider({
  preview = 'live',
  children
}: {
  preview?: WaitlistPreviewState;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const openWaitlist = useCallback((placement: string) => {
    trackEvent('mcp_waitlist_cta_click', {
      placement
    });
    setOpen(true);
  }, []);
  return <McpWaitlistContext.Provider value={{
    openWaitlist,
    preview
  }} data-id="element-1704" data-mp="3c1oncvvpxsrx">
      {children}
      <Dialog open={open} onClose={close} labelledBy="mcp-popup-title" className="max-h-[92vh] max-w-lg overflow-y-auto" data-id="element-1705" data-mp="3bzbuhnof9y03">
        <div className="flex items-start justify-between gap-4 border-b border-hairline px-6 pb-4 pt-6" data-id="element-1706" data-mp="3238schtklzd5">
          <div data-id="element-1707" data-mp="3psl0rfh2q3ee">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-lime" data-id="element-1708" data-mp="3pu4h162qceg6">Developer access · Waitlist open</p>
            <h2 id="mcp-popup-title" className="mt-1.5 text-xl font-semibold tracking-[-0.015em] text-text-primary" data-id="element-1709" data-mp="3uro3gt9kzxj7">
              Join the MCP waitlist
            </h2>
            <p className="mt-1 text-sm text-text-secondary" data-id="element-1710" data-mp="3l1l7ck75y3gn">Get access to DiligenceGPT™ agents in your own workflow.</p>
          </div>
          <button type="button" onClick={close} aria-label="Close" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-text-tertiary hover:bg-elevated hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1711" data-mp="cl9vdaxzuhsq">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-1712" data-mp="i8bosdokn0zq" />
          </button>
        </div>
        <div className="p-6" data-id="element-1713" data-mp="d9h93klwhsju">
          <McpWaitlistForm idPrefix="mcp-popup" bare data-id="element-1714" data-mp="daa4xqjbmxn7" />
        </div>
      </Dialog>
    </McpWaitlistContext.Provider>;
}